export default __webpack_public_path__ + "static/media/jenny.5d935257.jpeg";